/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Apr 04 2025
 **/

import { ReactNode, useEffect, useRef } from "react";

import { EventHandler } from "@rfice/eventhandler";

import MinimizeDraggable, { DraggableHandle } from "./MinimizeDraggable";

type MinimizeDraggerWrapperProps = {
	minimize: boolean;
	ratio: number;
	zIndex: number;
	displayName: string;
	children: ReactNode;
};

export default function MinimizeDraggableWrapper(props: MinimizeDraggerWrapperProps) {
	const { minimize, ratio, zIndex, displayName, children } = props;

	const draggableRef = useRef<DraggableHandle>(null);

	useEffect(() => {
		// reset draggable position
		const coordinate = {
			x: minimize ? (window.innerWidth * (1 - ratio)) / 2 : 0,
			y: minimize ? (window.innerHeight * (1 - ratio)) / 2 : 0
		};
		draggableRef.current?.reset(coordinate);

		// toggle unity render
		const payload = {
			state: minimize ? "unmount" : "mount",
			name: displayName
		};
		EventHandler.fire("$Detect::UIState$", payload);
	}, [minimize]);

	return (
		<MinimizeDraggable ref={draggableRef} zIndex={zIndex} minimize={minimize}>
			{children}
		</MinimizeDraggable>
	);
}
